// src/serviceWorkerRegistration.js

// Prüfen, ob Service Worker im Browser unterstützt wird
export function register() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      // Stelle sicher, dass der Service Worker über den richtigen Pfad geladen wird
      navigator.serviceWorker
        .register("/serviceWorker.js")
        .then((registration) => {
          console.log("Service Worker registriert:", registration);
        })
        .catch((error) => {
          console.error("Fehler bei der Service Worker-Registrierung:", error);
        });
    });
  }
}
